export default "__VITE_ASSET__Ccv8JEGG__"